import { render, staticRenderFns } from "./public_teacher_policy_interpretation.vue?vue&type=template&id=b0ed3a12&scoped=true"
import script from "./public_teacher_policy_interpretation.vue?vue&type=script&lang=js"
export * from "./public_teacher_policy_interpretation.vue?vue&type=script&lang=js"
import style0 from "./public_teacher_policy_interpretation.vue?vue&type=style&index=0&id=b0ed3a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ed3a12",
  null
  
)

export default component.exports